import { api } from './client.js';

/** 원본 marketing/email_download.php */
export interface ExportFile {
  name: string;
  size: number;
  modifiedAt: string;
}

export interface ExportListing {
  dir: string;
  files: ExportFile[];
}

export const exportsApi = {
  listEmails: () => api.get<ExportListing>('/exports/emails'),
  deleteEmail: (name: string) =>
    api.del<{ deleted: string }>(`/exports/emails/${encodeURIComponent(name)}`),
  /** 내려받기는 브라우저가 직접 받도록 주소만 준다. */
  downloadUrl: (name: string) => `/api/exports/emails/${encodeURIComponent(name)}`,
};
